import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { OnboardingPage } from './pages/OnboardingPage';
import { DashboardPage } from './pages/DashboardPage';
import { BusquedasPage } from './pages/BusquedasPage';
import { AlertasPage } from './pages/AlertasPage';
import { TeamPage } from './pages/TeamPage';
import { BillingPage } from './pages/BillingPage';
import { IntegrationsPage } from './pages/IntegrationsPage';
import { AdminPage } from './pages/AdminPage';
import { ProfilePage } from './pages/ProfilePage';
import { InboxPage } from './pages/InboxPage';
import { GuardadosPage } from './pages/GuardadosPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LoginPage data-id="element-3" />} data-id="element-2" />
        <Route path="/onboarding" element={<OnboardingPage data-id="element-5" />} data-id="element-4" />
        <Route path="/dashboard" element={<DashboardPage data-id="element-7" />} data-id="element-6" />
        <Route path="/inbox" element={<InboxPage data-id="element-9" />} data-id="element-8" />
        <Route path="/guardados" element={<GuardadosPage data-id="element-11" />} data-id="element-10" />
        <Route path="/alertas" element={<AlertasPage data-id="element-13" />} data-id="element-12" />
        <Route path="/busquedas" element={<BusquedasPage data-id="element-15" />} data-id="element-14" />
        <Route path="/equipo" element={<TeamPage data-id="element-17" />} data-id="element-16" />
        <Route path="/facturacion" element={<BillingPage data-id="element-19" />} data-id="element-18" />
        <Route path="/integraciones" element={<IntegrationsPage data-id="element-21" />} data-id="element-20" />
        <Route path="/admin" element={<AdminPage data-id="element-23" />} data-id="element-22" />
        <Route path="/perfil" element={<ProfilePage data-id="element-25" />} data-id="element-24" />
        {/* Redirect unknown routes to login */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-27" />} data-id="element-26" />
      </Routes>
    </BrowserRouter>;
}